module.exports = "<app-header></app-header>\r\n<div class=\"container\">\r\n  <app-alert></app-alert>\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <router-outlet></router-outlet>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main